import React from "react";
import "./topCard.scss";
import { Link } from "react-router-dom";
import { Stack, Skeleton } from "@mui/material";

// Icon
import CurrencyRupeeRoundedIcon from "@mui/icons-material/CurrencyRupeeRounded";

const TopCard = ({ item, topLoading }) => {
  return (
    <Stack className="top-card" spacing={2}>
      <div className="title-card">{item.title}</div>
      <div className="main-data">
        {topLoading ? <Skeleton animation="wave" /> : item.value}
        {/* {topLoading ? item.value : <Skeleton animation="wave" width="50%" />} */}
      </div>
      <div className="link-and-icon">
        <Link className="link" to={!topLoading && item.linkTo}>
          {item.linkName}
        </Link>
        <div
          className="icon-container"
          style={{ background: item.backgroundIcon, color: item.colorIcon }}
        >
          {item.icon}
        </div>
      </div>
    </Stack>
  );
};

export default TopCard;
